import { Link } from 'react-router-dom';
import { Layout, Header } from '../components/mte/shell';
import styles from './ComingSoon.module.css';

function ComingSoon(): JSX.Element {
  return (
    <Layout
      context="adulte"
      width="narrow"
      header={
        <Header
          context="adulte"
          logo={
            <Link to="/" className={styles.brand} aria-label="Retour à l'accueil Mon Temps d'Étude">
              <span className={styles.brandMark} aria-hidden="true">✦</span>
              <span className={styles.brandText}>Mon Temps d'Étude</span>
            </Link>
          }
        />
      }
      footer={<footer className={styles.footer}><p>Mon Temps d'Étude · Site en préparation</p></footer>}
    >
      <main className={styles.main} aria-labelledby="bientot-title">
        <section className={styles.panel}>
          <div className={styles.badge}>Bientôt disponible</div>
          <p className={styles.eyebrow}>Mon Temps d'Étude</p>
          <h1 id="bientot-title" className={styles.title}>Les inscriptions ouvriront prochainement</h1>
          <p className={styles.lede}>
            Nous finalisons avec soin l'univers Mon Temps d'Étude. Pour le moment,
            la création de nouveaux comptes reste fermée.
          </p>
          <div className={styles.separator} aria-hidden="true" />
          <p className={styles.note}>
            Vous avez déjà un compte ? Vous pouvez vous connecter dès maintenant.
          </p>
          <div className={styles.actions}>
            <Link to="/entree/" className={styles.primaryButton}>Se connecter</Link>
            <Link to="/" className={styles.secondaryButton}>← Retour à l'accueil</Link>
          </div>
        </section>
      </main>
    </Layout>
  );
}

export default ComingSoon;
